import { useTranslation } from 'react-i18next';
import { Service, ServiceGroup, ServiceServiceGroups, TenantBusiness } from '@turizi/shared';
import { Badge, Button, Card, Text, Group, Stack, Divider } from '@mantine/core';
import ServiceCardPrivate from './service-card-private';
import { IconGift, IconPackage, IconPlus } from '@tabler/icons-react';


// TODO: add client discount to the service groups and limit by publicPage

interface Props {
    serviceGroups: ServiceGroup[];
    onSelect?: (service_links: ServiceServiceGroups[]) => void;
}

export default function ServiceGroupsList({
    serviceGroups,
    onSelect,
}: Props): JSX.Element {
    const { t } = useTranslation();

    return (
        <div className="space-y-6">
            {serviceGroups.map(group => (
                <div
                    key={'group-' + group.id}
                    className="solid-box-border-blue"
                >
                    <Group gap="md">
                        {onSelect && (
                            <Button
                                size="xs"
                                radius="xl"
                                color="black"
                                // variant="subtle"
                                onClick={() => onSelect(group.service_links)}
                            >
                                {t('select')}
                            </Button>
                        )}
                        <div>
                            <Text size="lg" fw={600}>
                                {group.name}
                            </Text>
                            <Text size="sm" c="dimmed">
                                {group.service_links?.length || 0} {t('services')} {t('included')}
                            </Text>
                        </div>
                    </Group>

                    <Stack gap="sm">
                        {group.service_links?.map(link => (
                            <div
                                key={'service-' + link.service_id}
                                className="relative bg-white rounded-lg p-3 border border-gray-200 hover:border-blue-300 transition-colors"
                            >
                                <div className="flex items-center gap-4">
                                    <div className="flex-1">
                                        <ServiceCardPrivate service={link.service} className="hover:bg-transparent" />
                                    </div>
                                    <Badge
                                        color={link.discount > 0 ? 'orange' : 'gray'}
                                        size="sm"
                                        className="shrink-0"
                                    >
                                        -{link.discount}%
                                    </Badge>
                                </div>
                            </div>
                        ))}
                    </Stack>
                </div>
            ))}
        </div>
    );
}
